import { useState } from 'react';
import Loading from './Loading';

interface TabProps {
  key: string;
  label: string;
  content: React.ReactNode;
}

interface TabsProps {
  tabs: TabProps[];
  isLoading?: boolean;
}

export const ProductDescriptionTabs = ({
  tabs,
  isLoading = false,
}: TabsProps) => {
  const [activeKey, setActiveKey] = useState(tabs[0]?.key);

  if (isLoading) return <Loading />;

  const activeTab = tabs.find((t) => t.key === activeKey);

  return (
    <div>
      {/* Tab navigation */}
      <div className="relative flex gap-1 rounded-md bg-secondary-cornflowerblue-100 p-1">
        {tabs.map((tab) => {
          const isActive = activeKey === tab.key;

          return (
            <button
              type="button"
              key={tab.key}
              onClick={() => setActiveKey(tab.key)}
              className={`
                relative z-10
                flex-1
                rounded-full
                py-2 xl:py-3 
                text-center
                text-xs xl:text-sm
                font-medium
                transition-colors
                duration-300
                ${
                  isActive
                    ? 'text-white font-semibold'
                    : 'text-primary-blue-500 hover:text-primary-blue-600'
                }
              `}
            >
              {tab.label}
            </button>
          );
        })}

        {/* Sliding active background */}
        <div
          className="absolute inset-y-1 rounded-md bg-primary-blue-500 transition-all duration-300 ease-in-out"
          style={{
            width: `calc(${100 / tabs.length}% - 4px)`,
            left: `calc(${
              (100 / tabs.length) *
              tabs.findIndex((tab) => tab.key === activeKey)
            }% + 2px)`,
          }}
        />
      </div>

      {/* Content */}
      <div className="px-4 py-2 text-xs text-grey-700">
        {activeTab?.content}
      </div>
    </div>
  );
};

export default ProductDescriptionTabs;
